import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface input {
    label: string;
    placeholder: string;
}

interface service {
    name: string,
    api: string,
}

@Component
/**
 * ProfileChargeWallet Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * Description of the Panel
     */
    @Prop() description!: string;

    /**
     * Input Label and Placeholder
     * Object including label and placeholder
     */
    @Prop({ default: () => {} }) input!: input;

    /**
     * Select Gates title
     */
    @Prop() selectGatesTitle!: string;

    /**
     * Credit Preview title
     */
    @Prop() creditTitle!: string;

    /**
     * Button Title
     */
    @Prop() button!: string;

    /**
     * Wallet Info
     * Used Types: Dashboard
     */
    @Prop() wallets!: Array<{[k: string]: any}>;

    /**
     * Fetch Gates Services
     */
    @Prop({ default: () => ({ name: 'Wallet', api: 'onlineGates' }) }) fetchGatesServices!: service;

    /**
     * Charge Wallet Service
     */
    @Prop({ default: () => ({ name: 'Wallet', api: 'onlineCharge' }) }) chargeWalletServices!: service;
}
